import smoothReflow from 'vue-smooth-reflow';

export default {
    mixins: [smoothReflow],
    data: () => ({
        open: false,
    }),
    mounted() {
        this.$smoothReflow();
    },
    render() {
        return this.$scopedSlots.default({
            open: this.open,
            toggleOpen: this.toggleOpen,
        });
    },
    methods: {
        toggleOpen() {
            this.open = !this.open;
        },
    },
};
